import { boolean, intersect, nullable, partial, string, struct } from 'io-ts/Decoder';

import { Type } from '../../../../../user/preferences/ui-settings-template/Type';
import { Type as UISettings } from '../../../../../user/preferences/ui-settings/Type';

export const Request = intersect(
	struct({
		type: Type,

		name: string,
		description: nullable(string),
		//
		settings: UISettings,
	})
)(
	partial({
		isFavourite: boolean,
	})
);
